export default __webpack_public_path__ + "static/media/page-not-found-icon.50807e12.svg";